module.exports = __webpack_public_path__ + "img/4_cobe.584cba40.jpg";